// src/components/MainPage.js
import React from 'react';
import { useSelector } from 'react-redux';
import styles from  './TopBuySell.module.css';
import BuySellTrends from '../components/BuySellTrends';
import LimitedAdvise from '../components/LimitedAdvise';

function MainPage() {

    const { isPremium } = useSelector(state => state.globalData);

    return (        
        <div className={styles.main_page}>
            <header className={styles.main_header}>
                <h1>Top Buy and Sell</h1>
            </header>
            <main>
                <section className={styles.content}>
                {!isPremium &&
                    <div style={{position:'absolute', right:'8%'}}>
                        <LimitedAdvise 
                            width="80px" 
                            height="20px" 
                            message="Limited" 
                            tooltipTitle="Why this page is limited?"
                            tooltipPhrases={[
                                "Up to 10 out of 50 symbols available"                                        
                            ]}
                            tooltipPosition="left"  /* Options: top, down, left, right */
                            tooltipWidth='300px'
                        />
                    </div>
                }<br/><br/>
                    <BuySellTrends/>
                </section>
            </main>                     
        </div>
    );
}

export default MainPage;






